const setAuth = (state, authStatus) => {
  state.isAuthenticated = authStatus
}

const setCanViewerShare = (state, payload) => {
  state.canViewerShare = payload
}

const setCanEditPresentation = (state, payload) => {
  state.canEditPresentation = payload
}

const setCurrentTokenValue = (state, currentTokenValue) => {
  state.currentTokenValue = currentTokenValue
}

const setAhaSequenceNumber = (state, payload) => {
  state.ahaSequenceNumber = payload
}

const setOffsetTime = (state, payload) => {
  state.offsetTime = payload
}

const setIsNewPresentation = (state, payload) => {
  state.isNewPresentation = payload
}

const setIsOfficeOnline = (state, payload) => {
  state.isOfficeOnline = payload
}

const setAddinPPTPlatform = (state, payload) => {
  state.addinPPTPlatform = payload
}

const setImportStatus = (state, payload) => {
  state.importStatus = payload
}

const setSlideSearchPopupVisibility = (state, payload) => {
  state.isShowingSlideSearchPopup = payload
}

export default {
  setAuth,
  setCanViewerShare,
  setCanEditPresentation,
  setCurrentTokenValue,
  setAhaSequenceNumber,
  setOffsetTime,
  setIsNewPresentation,
  setIsOfficeOnline,
  setImportStatus,
  setSlideSearchPopupVisibility,
  setAddinPPTPlatform,
}
